import styled from "styled-components"

const ImageStyled = styled.img`
  height: auto;
  object-fit: contain;
  max-width: 100px;
`

export default ImageStyled
